import {
    RECEIVE_CREATE_SKILL_GROUP,
    REQUEST_CREATE_SKILL_GROUP,
    UPDATE_CREATE_SKILL_GROUP_VALUES,
    CLEAR_CREATE_SKILL_GROUP_VALUES
} from "../constants/actionTypes"


const initialState = {
    name: "",
    skillGroupNameValid: false,
    showModal: false,
    hideModal: false,
    isRequesting: false
}

export const createSkillGroupData = (state = initialState, action) => {
    switch(action.type) {
        case UPDATE_CREATE_SKILL_GROUP_VALUES:{
            let newState = {
                ...state,
                ...action.values
            };

            return newState;
        }

        case REQUEST_CREATE_SKILL_GROUP:{
            return {
                ...state,
                isRequesting: true
            }
        }

        case CLEAR_CREATE_SKILL_GROUP_VALUES:{
            return initialState;
        }

        case RECEIVE_CREATE_SKILL_GROUP:{
            return {
                ...state,
                hideModal: true,
                isRequesting: false
            }
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/createSkillGroupData.js